export function getValue(key) {
    return window.localStorage.getItem(key);
}

export function setValue(key,val) {
    return window.localStorage.setItem(key,val);
}


